import React from "react";
import { Box, Text, Image, Stack } from "@chakra-ui/react";
import redMountain from "../../../assets/about/bluebgupper.png"; // replace with your image path

const Heroteam = () => {
  return (
    <Box
      bg="#015F77" 
      color="white"
      textAlign="center"
      py={{ base: 32, md: 40 }}
      position="relative"
      overflow="hidden"
    >
      <Stack spacing={3}>
        <Text
          fontSize={{ base: "lg", md: "xl" }}
          fontStyle="italic"
          fontWeight="semibold"
          color="#B18E64"
          className="fade-in-up"
        >
          Meet the Doggle squad
        </Text>

        <Text
          fontSize={{ base: "2xl", md: "4xl", lg: "5xl" }}
          fontWeight="bold"
          className="fade-in-up"
        >
          Where Creativity Meets Chaos!
        </Text>
      </Stack>

      {/* Red Decorative Image at Bottom Right */}
      <Image
        src={redMountain}
        alt="decorative"
        position="absolute"
        bottom="0"
        right="0"
        w={{ base: "100%", sm: "80%", md: "70%", lg: "60%" }}
        maxH="200px"
        objectFit="contain"
        zIndex={1}
      />
    </Box>
  );
};

export default Heroteam;
